{
  "familyId": "TGL-TIJD-DUUR",
  "questions": [
    {
      "id": "TGL-TIJD-DUUR-001",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TGL",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "De les begint om 09:00 en eindigt om 10:30. Hoe lang duurt de les?",
      "options": [
        "1 uur en 30 minuten",
        "1 uur",
        "2 uur",
        "30 minuten"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tijdsduur berekenen",
            "content": "Stap 1: ga naar het volgende hele uur (09:00 → 10:00 = 1 uur). Stap 2: tel de resterende minuten (10:00 → 10:30 = 30 min). Totaal: 1 uur + 30 min = 1 uur en 30 minuten."
          }
        }
      ],
      "conceptId": "time_duration_lesson",
      "variantIndex": 1,
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: bereken de tijdsduur door eerst naar het volgende hele uur te gaan, dan de rest. Stap 1: 09:00 → 10:00 = 1 uur. Stap 2: 10:00 → 10:30 = 30 minuten. Stap 3: totaal = 1 uur + 30 minuten = 1 uur en 30 minuten.",
        "distractorExplanations": {
          "0": "Correct! De les duurt 1 uur en 30 minuten (van 09:00 tot 10:30).",
          "1": "Veelgemaakte fout: alleen het hele uur tellen. Je telt 09:00 → 10:00 = 1 uur, maar vergeet de extra 30 minuten (10:00 → 10:30). Totaal: 1 uur + 30 min.",
          "2": "Veelgemaakte fout: naar het verkeerde uur rekenen. Van 09:00 tot 10:30 is geen 2 uur. Reken: 09:00 → 10:00 = 1 uur, dan 10:00 → 10:30 = 30 min. Totaal: 1,5 uur.",
          "3": "Veelgemaakte fout: het hele uur vergeten. 30 minuten is alleen het laatste deel (10:00 → 10:30). Je vergeet het hele uur van 09:00 → 10:00."
        }
      }
    },
    {
      "id": "TGL-TIJD-DUUR-002",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TGL",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "De trein vertrekt om 13:45 en komt aan om 15:20. Hoe lang duurt de reis?",
      "options": [
        "1 uur en 35 minuten",
        "1 uur en 25 minuten",
        "2 uur en 35 minuten",
        "1 uur en 45 minuten"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 13,
            "end": 16,
            "markers": [
              13.75,
              15.33
            ],
            "label": "Tijdlijn: vertrek (13:45) en aankomst (15:20)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tijdsduur over uurgrens",
            "content": "Stap 1: 13:45 → 14:00 = 15 minuten. Stap 2: 14:00 → 15:00 = 1 uur. Stap 3: 15:00 → 15:20 = 20 minuten. Totaal: 15 min + 1 uur + 20 min = 1 uur en 35 minuten."
          }
        }
      ],
      "conceptId": "time_duration_train",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Strategie: splits de berekening op bij de uurgrens. Stap 1: 13:45 → 14:00 = 15 minuten. Stap 2: 14:00 → 15:00 = 1 uur (= 60 minuten). Stap 3: 15:00 → 15:20 = 20 minuten. Stap 4: totaal = 15 + 60 + 20 = 95 minuten = 1 uur en 35 minuten.",
        "distractorExplanations": {
          "0": "Correct! De reis duurt 1 uur en 35 minuten (15 min + 60 min + 20 min = 95 min).",
          "1": "Veelgemaakte fout: de minuten vóór het hele uur verkeerd tellen. Van 13:45 → 14:00 = 15 minuten (60 − 45 = 15), niet 5 minuten. Totaal: 15 + 60 + 20 = 95 min.",
          "2": "Veelgemaakte fout: een extra uur tellen. Van 13:45 tot 15:20 is iets meer dan 1,5 uur, niet 2,5 uur. Reken stap voor stap via de uurgrens.",
          "3": "Veelgemaakte fout: de deelminuten verkeerd optellen. 15 min + 20 min = 35 minuten (niet 45 minuten). Totaal: 1 uur en 35 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-DUUR-003",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TGL",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Een voetbalwedstrijd begint om 14:30 en duurt 90 minuten. Hoe laat is de wedstrijd afgelopen?",
      "options": [
        "16:00",
        "15:30",
        "16:30",
        "15:00"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "90 minuten omzetten",
            "content": "90 minuten = 1 uur en 30 minuten. Dus: 14:30 + 1 uur = 15:30, dan + 30 minuten = 16:00."
          }
        }
      ],
      "conceptId": "time_duration_sports",
      "variantIndex": 3,
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: zet minuten om naar uren en minuten, dan tel je op. Stap 1: 90 minuten = 60 + 30 = 1 uur en 30 minuten. Stap 2: 14:30 + 1 uur = 15:30. Stap 3: 15:30 + 30 minuten = 16:00.",
        "distractorExplanations": {
          "0": "Correct! 14:30 + 90 minuten (= 1 uur en 30 minuten) = 16:00.",
          "1": "Veelgemaakte fout: maar 1 uur bijtellen. 90 minuten = 1 uur en 30 minuten, niet alleen 1 uur. Na 14:30 + 1 uur = 15:30 moet je nog 30 minuten bijtellen: 16:00.",
          "2": "Veelgemaakte fout: 90 minuten afronden naar 2 uur. 90 minuten = 1 uur en 30 minuten (niet 2 uur). 14:30 + 2 uur = 16:30, maar het juiste antwoord is 16:00.",
          "3": "Veelgemaakte fout: maar 30 minuten bijtellen. 90 minuten = 1 uur en 30 minuten, niet alleen 30 minuten. 14:30 + 30 min = 15:00, maar je moet nog 1 uur bijtellen: 16:00."
        }
      }
    },
    {
      "id": "TGL-TIJD-DUUR-004",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TGL",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Je begint met huiswerk om 16:15 en bent klaar om 17:40. Hoe lang deed je over je huiswerk?",
      "options": [
        "1 uur en 25 minuten",
        "1 uur en 15 minuten",
        "1 uur en 35 minuten",
        "2 uur"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap rekenen",
            "content": "16:15 → 17:00 = 45 minuten. 17:00 → 17:40 = 40 minuten. Totaal: 45 + 40 = 85 minuten = 1 uur en 25 minuten."
          }
        }
      ],
      "conceptId": "time_duration_homework",
      "variantIndex": 4,
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: splits de berekening op bij de uurgrens. Stap 1: 16:15 → 17:00 = 45 minuten (60 − 15 = 45). Stap 2: 17:00 → 17:40 = 40 minuten. Stap 3: totaal = 45 + 40 = 85 minuten = 1 uur en 25 minuten.",
        "distractorExplanations": {
          "0": "Correct! Je deed 1 uur en 25 minuten over je huiswerk (45 + 40 = 85 min).",
          "1": "Veelgemaakte fout: de minuten vóór het hele uur verkeerd tellen. Van 16:15 → 17:00 = 45 minuten (60 − 15 = 45), niet 35 minuten.",
          "2": "Veelgemaakte fout: de deelminuten verkeerd optellen. 45 + 40 = 85 minuten = 1 uur en 25 minuten (85 − 60 = 25), niet 1 uur en 35 minuten.",
          "3": "Veelgemaakte fout: naar het verkeerde uur rekenen. Van 16:15 tot 17:40 is iets meer dan 1 uur, niet 2 uur. Reken stap voor stap via de uurgrens."
        }
      }
    },
    {
      "id": "TGL-TIJD-DUUR-005",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TGL",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "De film begint om 14:00 en duurt 1 uur en 45 minuten. Hoe laat is de film afgelopen?",
      "options": [
        "15:45",
        "15:15",
        "16:00",
        "15:30"
      ],
      "correctAnswer": 0,
      "conceptId": "time_duration_calculation",
      "variantIndex": 5,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Tijd erbij tellen",
            "content": "14:00 + 1 uur = 15:00. Dan + 45 minuten = 15:45. De film is om 15:45 afgelopen."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: tel de uren en minuten apart op bij de begintijd. Stap 1: 14:00 + 1 uur = 15:00. Stap 2: 15:00 + 45 minuten = 15:45. Stap 3: de film is om 15:45 afgelopen.",
        "distractorExplanations": {
          "0": "Correct! 14:00 + 1 uur = 15:00, dan + 45 minuten = 15:45.",
          "1": "Veelgemaakte fout: het verkeerde aantal minuten bijtellen. Je telde 15 minuten in plaats van 45 minuten. 14:00 + 1 uur + 45 min = 15:45, niet 15:15.",
          "2": "Veelgemaakte fout: 45 minuten afronden naar 1 uur. 45 minuten is geen heel uur. 14:00 + 1 uur + 45 min = 15:45, niet 14:00 + 2 uur = 16:00.",
          "3": "Veelgemaakte fout: 45 minuten verwarren met 30 minuten (half uur). 45 minuten is een kwartier meer dan een half uur. 14:00 + 1 uur + 45 min = 15:45, niet 15:30."
        }
      }
    },
    {
      "id": "TGL-TIJD-DUUR-006",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TGL",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "multiple_choice",
      "question": "Hoeveel dagen heeft de maand februari in een gewoon jaar (geen schrikkeljaar)?",
      "options": [
        "28",
        "30",
        "29",
        "31"
      ],
      "correctAnswer": 0,
      "conceptId": "calendar_days_months",
      "variantIndex": 6,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Dagen in februari",
            "content": "Februari heeft 28 dagen in een gewoon jaar. Alleen in een schrikkeljaar (om de 4 jaar) heeft februari 29 dagen."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: leer de uitzonderingen — februari is de enige maand met minder dan 30 dagen. Stap 1: de meeste maanden hebben 30 of 31 dagen. Stap 2: februari is de uitzondering: 28 dagen in een gewoon jaar, 29 in een schrikkeljaar. Stap 3: de vraag gaat over een gewoon jaar, dus 28 dagen.",
        "distractorExplanations": {
          "0": "Correct! Februari heeft 28 dagen in een gewoon jaar.",
          "1": "Veelgemaakte fout: februari verwarren met maanden van 30 dagen. April, juni, september en november hebben 30 dagen. Februari is korter: 28 dagen.",
          "2": "Veelgemaakte fout: schrikkeljaar en gewoon jaar verwarren. 29 dagen heeft februari alleen in een schrikkeljaar (om de 4 jaar). In een gewoon jaar: 28 dagen.",
          "3": "Veelgemaakte fout: februari verwarren met maanden van 31 dagen. Januari, maart, mei, juli, augustus, oktober en december hebben 31 dagen. Februari is de kortste: 28 dagen."
        }
      }
    },
    {
      "id": "TGL-TIJD-DUUR-007",
      "familyId": "TGL-TIJD-DUUR",
      "module": "TGL",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_duur_berekenen",
      "questionType": "fill_in",
      "question": "De film begint om 14:30 en eindigt om 16:15. Hoeveel minuten duurt de film?",
      "options": [
        "105",
        "95",
        "115",
        "125"
      ],
      "correctAnswer": 0,
      "data": {
        "acceptableAnswers": ["105"],
        "placeholder": "Typ het aantal minuten",
        "caseSensitive": false
      },
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Minuten berekenen",
            "content": "14:30 → 15:00 = 30 minuten. 15:00 → 16:00 = 60 minuten. 16:00 → 16:15 = 15 minuten. Totaal: 30 + 60 + 15 = 105 minuten."
          }
        }
      ],
      "conceptId": "time_duration_fill_in",
      "variantIndex": 7,
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: splits de berekening op bij de uurgrens en tel alle minuten op. Stap 1: 14:30 → 15:00 = 30 minuten. Stap 2: 15:00 → 16:00 = 60 minuten. Stap 3: 16:00 → 16:15 = 15 minuten. Stap 4: totaal = 30 + 60 + 15 = 105 minuten.",
        "distractorExplanations": {
          "0": "Correct! De film duurt 105 minuten (30 + 60 + 15).",
          "1": "Veelgemaakte fout: de minuten vóór het hele uur verkeerd tellen. Van 14:30 → 15:00 = 30 minuten (60 − 30 = 30), niet 20 minuten. Totaal: 30 + 60 + 15 = 105.",
          "2": "Veelgemaakte fout: een stap te veel tellen. Controleer: 30 + 60 + 15 = 105, niet 115. Tel de drie delen nauwkeurig op.",
          "3": "Veelgemaakte fout: een extra stap tellen. 30 + 60 + 15 = 105 minuten, niet 125. Controleer elke stap apart."
        }
      }
    }
  ]
}